import React from 'react';
import colors from '../../utils/colors';
import typography from '../../utils/typography';

const IncomingMessage = ({ message }) => {
  return (
    <div className="flex justify-start">
      <div className="max-w-[80%]">
        <p
          style={{
            ...typography.medium.regular,
            color: colors.text.primary
          }}
        >
          {message}
        </p>
      </div>
    </div>
  );
};

export default IncomingMessage;